import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { ExchangeActions } from "../actions/exchange.actions";
import { OrderProposalActions } from "../actions/order-proposal.actions";
import { ProposalsByProductState } from "../models/proposal-by-product.state";

const initialState: ProposalsByProductState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(OrderProposalActions.proposalsByProduct.getSuccess, (state, action) =>
		_.omit(action, "type")
	),
	on(OrderProposalActions.proposalsByProduct.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	),
	on(ExchangeActions.proposalsByProduct.getSuccess, (state, action) => _.omit(action, "type")),
	on(ExchangeActions.proposalsByProduct.getSuccess, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function proposalsByProductReducer(
	state: ProposalsByProductState | undefined,
	action: Action
): ProposalsByProductState {
	return reducer(state, action);
}
